import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Land Bank",
    body: "920 square kilometres of government-pooled, title-screened land — plotted, trunk-serviced and released in phases. You are not buying a promise. You are buying a surveyed parcel inside a notified Special Investment Region.",
    metric: "920 SQ KM",
    metricLabel: "Notified SIR footprint",
  },
  {
    num: "02",
    title: "Connectivity",
    body: "A 109 km access-controlled expressway to Ahmedabad, a greenfield international airport turning operational in 2026, and an approved metro spine. Every parcel we list is mapped against these arteries.",
    metric: "2026",
    metricLabel: "Airport operations begin",
  },
  {
    num: "03",
    title: "Industry",
    body: "Semiconductor fabrication, a 5,000 MW solar park and defence manufacturing are anchoring demand. Industrial absorption pulls the residential and commercial plots around it upward.",
    metric: "₹91,000 CR",
    metricLabel: "Anchored fab investment",
  },
];

export default function Manifesto() {
  return (
    <section id="thesis" className="relative" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-mono text-[11px] uppercase tracking-[0.3em] text-accent"
        >
          Sec. 01 — The Thesis
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
          className="mt-5 font-display text-3xl font-medium uppercase tracking-tight md:text-5xl"
        >
          Why Dholera.
          <br />
          Why now.
        </motion.h2>

        <div className="mt-14 border-t border-border md:mt-20">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="grid gap-6 border-b border-border py-10 md:grid-cols-12 md:py-14"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="font-display text-6xl font-light leading-none md:col-span-3 md:text-8xl">
                <span className="text-outline-faint">{c.num}</span>
              </div>
              <div className="md:col-span-6">
                <h3 className="font-display text-xl font-medium uppercase tracking-tight md:text-2xl">
                  {c.title}
                </h3>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground md:text-base">
                  {c.body}
                </p>
              </div>
              <div className="flex flex-col justify-center md:col-span-3 md:border-l md:border-border md:pl-8">
                <p className="font-display text-3xl font-extrabold tracking-tight text-accent md:text-4xl">
                  {c.metric}
                </p>
                <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
                  {c.metricLabel}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
